import type { CriteriaChoiceUserType } from '~/model/CriteriaChoiceType';
import type { CriteriaType } from '~/model/CriteriaType';
import { useEffect, useState } from 'react';
import { hasMissingMandatoryCriteria } from '~/utils/criteria/mandatory';
import { useAuthenticatedContext, useProgressContext } from '../components/Provider';
import { isGuestUser } from '../utils/entities/user';

export function useProfileCompletion({
  requestedCriteria: baseRequestedCriteria,
  requestedCriteriaChoiceUser,
  mandatoryCriteria,
  mandatoryCriteriaChoiceUser,
  shouldUpdateSports,
}: {
  requestedCriteria: Array<CriteriaType>;
  requestedCriteriaChoiceUser: Array<CriteriaChoiceUserType>;
  mandatoryCriteria: Array<CriteriaType>;
  mandatoryCriteriaChoiceUser: Array<CriteriaChoiceUserType>;
  shouldUpdateSports: boolean;
}) {
  const { setTotal } = useProgressContext();
  const { user } = useAuthenticatedContext();

  const totalCriteria = (baseRequestedCriteria?.length || 0)
    + (mandatoryCriteria ? 1 : 0)
    + (shouldUpdateSports ? 1 : 0);

  const [isMandatoryCompletionClosed, setIsMandatoryCompletionClosed] = useState(!mandatoryCriteria);
  const [isSportsCompletionClosed, setIsSportsCompletionClosed] = useState(!shouldUpdateSports);
  const [requestedCriteria, setRequestedCriteria] = useState(baseRequestedCriteria);
  const [hasStarted, setHasStarted] = useState(!totalCriteria);

  const displayMandatoryCriteria = !isMandatoryCompletionClosed && hasMissingMandatoryCriteria(mandatoryCriteriaChoiceUser);
  const displaySportsCompletion = !displayMandatoryCriteria && !isSportsCompletionClosed;
  const displayCriterionForm = !displayMandatoryCriteria && !displaySportsCompletion && !!requestedCriteria?.length;
  const displayMandatoryCriteriaEnd = !displayMandatoryCriteria && !displaySportsCompletion && !requestedCriteria?.length;

  useEffect(() => {
    setTotal((current) => {
      return current + totalCriteria + (isGuestUser(user) ? 1 : 0);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id]);

  return {
    displayCriterionForm,
    displayMandatoryCriteria,
    displayMandatoryCriteriaEnd,
    displaySportsCompletion,
    setIsMandatoryCompletionClosed,
    setIsSportsCompletionClosed,
    requestedCriteria,
    setRequestedCriteria,
    requestedCriteriaChoiceUser,
    mandatoryCriteria,
    mandatoryCriteriaChoiceUser,
    hasStarted,
    setHasStarted,
    shouldUpdateSports,
  };
}
